import {
  gearboxMarketCompressor,
  gearboxMarketConfigurators,
} from '@1delta/data-sdk'
import { zeroAddress } from 'viem'

/**
 * Builds the multicall descriptor for Gearbox V3.1 passive-pool data.
 *
 * Shares the same `MarketCompressor.getMarkets(filter)` call as the
 * lending public-data fetcher — the response carries every pool's
 * underlying, symbol, totals, rates, withdrawFee and diesel rate inside
 * the `pool` sub-struct of each `MarketData` entry. No per-pool
 * follow-up calls are needed.
 */
export const buildGearboxV3PoolsCall = (chainId: string) => {
  const compressor = gearboxMarketCompressor()
  const configurators = gearboxMarketConfigurators(chainId)
  if (!compressor || !configurators) return []

  const curatorAddrs = Object.keys(configurators)
  if (curatorAddrs.length === 0) return []

  return [
    {
      address: compressor,
      name: 'getMarkets',
      params: [
        {
          configurators: curatorAddrs,
          pools: [] as string[],
          underlying: zeroAddress,
        },
      ],
    },
  ]
}
